/**
 * 我的任务-所有任务模块
 * myAllAssignments
 * author: Qian.qianchen 2019-05-08
 */
"use strict";
angular.module('myAllAssignmentsModule', [])
    .controller('myAllAssignmentsCtrl', ['$scope', 'trsHttpService', '$state', '$q', 'modalDialog', 'taskAssignmentService', 'trsspliceString', function($scope, trsHttpService, $state, $q, modalDialog, taskAssignmentService, trsspliceString) {
        initStatus();
        initData();
        /**
         * [initStatus description] 状态初始化
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                isOnlyToday: false,
                keyword: "",
                page: {
                    CURRPAGE: 1,
                    PAGESIZE: 10
                },
                params: {
                    serviceid: "mlf_taskcommand",
                    methodname: "queryTaskCommands",
                    IsMine: 1,
                    BeginDate: "",
                    EndDate: "",
                    TaskName: "",

                },
                statusOptions: taskAssignmentService.initStatus(1),
                selectedOption: {
                    name: "全部状态",
                    value: -2
                }
            };
            $scope.data = {
                selectedArray: []
            }
        }
        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
        }
        /**
         * [requestData description] 数据获取
         * @return {[type]} [description]
         */
        function requestData() {
            let defer = $q.defer();
            let params = angular.copy($scope.status.params);
            params.TaskName = $scope.status.keyword;
            params.BeginDate = angular.isDefined($scope.data.fromdate) && $scope.data.fromdate != "" ? $scope.data.fromdate : "";
            params.EndDate = angular.isDefined($scope.data.untildate) && $scope.data.untildate != "" ? $scope.data.untildate : "";
            params.Status = $scope.status.selectedOption.value != -2 ? $scope.status.selectedOption.value : "";
            params.Today = $scope.status.isOnlyToday ? 1 : "";
            params.PageSize = $scope.status.page.PAGESIZE;
            params.CurrPage = $scope.status.page.CURRPAGE;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "POST").then(function(data) {
                $scope.data.items = data.DATA;
                $scope.status.page = data.PAGER;
            });
        }
        /**
         * [editAssignment description] 新建任务
         * @return {[type]} [description]
         */
        $scope.editAssignment = function(assignment) {
            let params;
            if (angular.isDefined(assignment)) {
                params = {
                    platform: 1,
                    assignmentid: assignment.TASKCOMMANDID
                };
            } else {
                params = {
                    platform: 1
                };
            }
            $state.go('front.plan.taskassignment.myassignments.assignmentedit', params);
        }
        /**
         * [initList description] 列表数据请求
         * @return {[type]} [description]
         */
        $scope.initList = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.status.page.CURRPAGE = 1;
                $scope.data.selectedArray = [];
                requestData();
            }
        }
        /**
         * [pageChanged description] 分页请求数据
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            requestData();
        }
        /**
         * [isChecked description] 判断稿件是否选中
         * @param  {[type]}  item [description] 稿件
         * @return {Boolean}      [description]
         */
        $scope.isChecked = function(item) {
            return $scope.data.selectedArray.some(function(_item, index) {
                return item.TASKCOMMANDID == _item.TASKCOMMANDID;
            });
        }
        /**
         * [selectItem description] 稿件选择/取消选择
         * @param  {[type]} item [description] 稿件
         * @return {[type]}      [description]
         */
        $scope.selectItem = function(item) {
            if ($scope.isChecked(item)) {
                $scope.data.selectedArray = $scope.data.selectedArray.filter(function(_item, index) {
                    return item.TASKCOMMANDID != _item.TASKCOMMANDID
                });
            } else {
                $scope.data.selectedArray.push(item)
            }
        }
        /**
         * [trialAssignment description] 送审任务
         * @param  {[type]} assignment [description] 任务
         * @return {[type]}            [description]
         */
        $scope.trialAssignment = function(assignment) {
            var defer = $q.defer();
            var taskIds = "",
                tips = "";
            if (angular.isDefined(assignment)) {
                taskIds = assignment.TASKCOMMANDID;
                tips = "是否确认送审该任务？";
            } else {
                taskIds = trsspliceString.spliceString($scope.data.selectedArray, 'TASKCOMMANDID', ',');
                tips = "是否确认送审选中的" + $scope.data.selectedArray.length + "个任务？";
            }
            var params = {
                serviceid: "mlf_taskcommand",
                methodname: "submitTask",
                TaskIds: taskIds
            };
            modalDialog.confirmModal('送审任务', tips, function() {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "POST").then(function(data) {
                    modalDialog.alertType('送审成功', '', 'success', false);
                    $scope.initList();
                    defer.resolve();
                }, function() {
                    $scope.initList();
                    defer.reject();
                });
            });
            return defer.promise;
        }
        /**
         * [acceptAssignment description] 接受任务
         * @param  {[type]} assignment [description] 任务
         * @return {[type]}            [description]
         */
        $scope.acceptAssignment = function(assignment) {
            var defer = $q.defer();
            var taskIds = "",
                tips = "";
            if (angular.isDefined(assignment)) {
                taskIds = assignment.TASKCOMMANDID;
                tips = "是否确认接受该任务？";
            } else {
                taskIds = trsspliceString.spliceString($scope.data.selectedArray, 'TASKCOMMANDID', ',');
                tips = "是否确认接受选中的" + $scope.data.selectedArray.length + "个任务？";
            }
            var params = {
                serviceid: "mlf_taskcommand",
                methodname: "acceptTask",
                TaskIds: taskIds
            };
            modalDialog.confirmModal('接受任务', tips, function() {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "POST").then(function(data) {
                    modalDialog.alertType('接受成功', '', 'success', false);
                    $scope.initList();
                    defer.resolve();
                }, function() {
                    $scope.initList();
                    defer.reject();
                });
            });
            return defer.promise;
        }
        /**
         * [finishAssignment description] 任务完成
         * @param  {[type]} assignment [description] 任务
         * @return {[type]}            [description]
         */
        $scope.finishAssignment = function(assignment) {
            var defer = $q.defer();
            var taskIds = "",
                tips = "";
            if (angular.isDefined(assignment)) {
                taskIds = assignment.TASKCOMMANDID;
                tips = "是否确认完成该任务？";
            } else {
                taskIds = trsspliceString.spliceString($scope.data.selectedArray, 'TASKCOMMANDID', ',');
                tips = "是否确认完成选中的" + $scope.data.selectedArray.length + "个任务？";
            }
            var params = {
                serviceid: "mlf_taskcommand",
                methodname: "completeTask",
                TaskIds: taskIds
            };
            modalDialog.confirmModal('完成任务', tips, function() {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "POST").then(function(data) {
                    modalDialog.alertType('接受成功', '', 'success', false);
                    $scope.initList();
                    defer.resolve();
                }, function() {
                    $scope.initList();
                    defer.reject();
                });
            });
            return defer.promise;
        }

        /**
         * [assignmentDetail description] 任务详情
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.assignmentDetail = function(item) {
            taskAssignmentService.assignmentDetail(item.TASKCOMMANDID, 1).then(function() {
                $scope.initList();
            });
        }
        /**
         * [assignmentLog description] 任务日志
         * @param  {[type]} item [description] 任务
         * @return {[type]}      [description]
         */
        $scope.assignmentLog = function(item) {
            taskAssignmentService.assignmentLog(item.TASKCOMMANDID);
        }
        /**
         * [todayToggle description] 只看当天
         * @return {[type]} [description]
         */
        $scope.todayToggle = function() {
            $scope.status.isOnlyToday = !$scope.status.isOnlyToday;
            $scope.initList();
        }
    }]);